/**
 * Decorative macOS-style browser-chrome wrapper used in hero + evaluation cards.
 * Purely presentational; `dark` variant inverts the bar for the USP section.
 */
function BrowserFrame({ domain, path, dark = false, children }) {
  return (
    <div className={`ul-browser-frame${dark ? " dark" : ""}`}>
      <div className="ul-browser-topbar">
        <div className="ul-browser-dots" aria-hidden="true">
          <span /><span /><span />
        </div>
        <div className="ul-browser-url">
          <span className="ul-url-lock" aria-hidden="true">🔒</span>
          <span className="ul-url-domain">{domain}</span>
          <span className="ul-url-path">{path}</span>
        </div>
      </div>
      {children}
    </div>
  );
}

export default BrowserFrame;
